/**
 * Top-level route table. Matches the new layered URL contract:
 *
 *   /                 → redirect to /checkout (preserves any query string)
 *   /checkout         → pay-now flow (tokenId + country + optional type + saveCard?)
 *   /order            → SmartHQ Phase B alias (tokenId + country; reads saved card)
 *   /save-card        → zero-auth tokenize flow (tokenId + country + optional type)
 *   /cards            → SmartHQ saved-card surface (tokenId + country)
 *   /status/:type     → success / pending / failed / error result page
 *   /summary          → SmartHQ Phase B outcome alias (maps to /status/success)
 */

import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import ErrorBoundary from './components/common/ErrorBoundary';
import CheckoutPage from './features/checkout/CheckoutPage';
import SavedCardsPage from './features/savedCards/SavedCardsPage';
import StatusPage from './features/status/StatusPage';
import SaveCardPage from './features/tokenize/SaveCardPage';

const App: React.FC = () => (
  <ErrorBoundary>
    <Routes>
      <Route path="/" element={<Navigate to="/checkout" replace />} />
      <Route path="/checkout-old" element={<CheckoutPage />} />
      <Route path="/order" element={<CheckoutPage />} />
      <Route path="/checkout" element={<SaveCardPage />} />
      <Route path="/cards" element={<SavedCardsPage />} />
      <Route path="/status/:type" element={<StatusPage />} />
      <Route path="/summary" element={<Navigate to="/status/success" replace />} />
      <Route path="*" element={<Navigate to="/status/error" replace />} />
    </Routes>
  </ErrorBoundary>
);

export default App;
